import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export const TableCell = ({ children, className, hasError, alignment = "left", beforeSlot, afterSlot, ...rest }) => {
    return (_jsx("td", { className: classNames("eds-table-cell", {
            "eds-table-cell--error": !!hasError,
            "eds-table-cell--right": alignment === "right",
        }, className), ...rest, children: _jsxs("div", { className: "eds-table-cell__content", children: [beforeSlot, children, afterSlot] }) }));
};
